import angular from "angular";

import {
  ReferenceObject,ReferenceObjectListItem,ReferenceObjects,
} from "@salaxy/core";

import { UiHelpers } from "../../services";
import { ApiCrudObjectController } from "../bases";

/**
 * FOR TESTING OR DEVELOPMENT USE ONLY - NOT FOR PRODUCTION USE.
 * =============================================================
 * Provides UI logic for viewing and adding new (modifying) Reference Objects
 * The implementation is based on the current development conventions.
 * The reference objects have no meaning or use outside development or testing environments, and they
 * should not be used in production for any business purpose.
 */
export class ReferenceObjectCrudController extends ApiCrudObjectController<ReferenceObject, ReferenceObjectListItem> {
  isSaving: boolean;
  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = [
    "ReferenceObjects",
    "UiHelpers",
    "$location",
    "$routeParams"
  ];

  constructor(
    api: ReferenceObjects,
    uiHelpers: UiHelpers,
    $location: angular.ILocationService,
    $routeParams: any
  ) { // Dependency injection
    super(api, uiHelpers, $location, $routeParams);
  }

  /** Implements the getDefaults of ApiCrudObjectController */
  public getDefaults() {
    return {
      listUrl: this.listUrl || "/reference-objects",
      detailsUrl: this.detailsUrl || "/reference-objects/details/",
      oDataTemplateUrl: "salaxy-components/odata/lists/ReferenceObjects.html",
      oDataOptions: {},
    };
  }
}